import http from '../../utils/httpService';
import { PROFILE_ROUTE, UPDATE_PROFILE_ROUTE, UPDATE_PROFILE_AVATAR_ROUTE } from './constants';

/**
 *
 * @returns {*}
 */
const requestProfile = () => (
    http.request( PROFILE_ROUTE, 'GET' )
);

/**
 *
 * @param formData
 * @returns {*}
 */
const requestUpdateProfile = ( formData ) => {
    const route = UPDATE_PROFILE_ROUTE;
    return http.request( route, 'PUT', formData );
};

/**
 *
 * @param avatarObj
 * @returns {*}
 */
export const requestAvatarUpload = ( avatarObj ) => {
    const requestBody = new FormData();
    requestBody.append( 'avatar', avatarObj );
    return http.request( UPDATE_PROFILE_AVATAR_ROUTE, 'POST', requestBody, true );
};

export {
    requestProfile,
    requestUpdateProfile
};
